import { createSelector } from 'reselect';
import { reportsFilterSelector } from '../screens/reports/lib/selectors.js';
import * as filterSelectors from './filterSelectors.js';
import * as serviceProviderSelectors from './serviceProviderSelectors.js';

export const reporting = (state) => state.reporting;
export const reportingUtmSourceList = createSelector(reporting, (reporting) => reporting.utmSources);
export const reportingUtmCampaignsList = createSelector(reporting, (reporting) => reporting.utmCampaigns);
export const reportsFilters = reportsFilterSelector(filterSelectors.filters, serviceProviderSelectors.serviceProviderId, serviceProviderSelectors.serviceProviderLocations, filterSelectors.filteredLocationId);
export const reportsTab = (state) => (String(state.router.location.pathname).includes('/reports') ? String(state.router.location.pathname || '').split('/')[3] || 'insights' : '');
